const _=require('pulsar-utils/dist-es6/_');let

BaseAxisController=class BaseAxisController{
get $inject(){return['$scope']}

constructor($scope){
if(this.orientation!=='vertical'&&this.orientation!=='horizontal'){
throw new Error('must specify orientation of \'vertical\' or \'horizontal\'');
}

this.myself=this;
this._lengthOnScreen=null;
this._scale=null;
this._range=null;

$scope.$watch('controller.plotArea',newPlotArea=>{
if(_.exists(newPlotArea)){
newPlotArea.registerAxis(this);
}
});

this.offset=this.offset||0;
}

get _scaleCreator(){
throw new Error('implement this!');
}

get scale(){
return this._scale;
}

get roundedScale(){
return this._roundedScale;
}

get lengthOnScreen(){
return this._lengthOnScreen;
}

set lengthOnScreen(newLength){
if(newLength===this._lengthOnScreen){
return;
}
this._lengthOnScreen=newLength;

switch(this.orientation){
case'horizontal':
this._range={start:this.offset,end:newLength+this.offset};
break;
case'vertical':
this._range={start:newLength+this.offset,end:this.offset};
break;}


this._updateScale();
}

_updateScale(){
if(_.exists(this.domain)&&_.exists(this._range)){
this._scale=this._scaleCreator.
domain([this.domain.start,this.domain.end]).
range([this._range.start,this._range.end]);

this._roundedScale=this._scaleCreator.
domain([this.domain.start,this.domain.end]).
rangeRound([this._range.start,this._range.end]);
}else
{
this._scale=null;
}
}};


module.exports=BaseAxisController;
//# sourceMappingURL=baseAxisController.js.map
